
/* Layout */
import Layout from '../views/layout/Layout'
export default {
    path: '/orderReturn',
    component: Layout,
    redirect: '/orderReturn/merchantList',
    name: 'orderReturn',
    meta: {
      title: '付款管理',
      icon: 'product-list'
    },
    children: [{
        path: 'orderReturnDetail',
        name: 'orderReturnDetail',
        component: () => import('@/views/orderReturn/orderReturnDetail/index'),
        meta: {
          title: '付款管理',
          icon: 'product-list'
        }
      },{
        path: 'transactionLog',
        name: 'transactionLog',
        component: () => import('@/views/orderReturn/transactionLog/index'),
        meta: {
          title: '支付记录查询',
          icon: 'product-list',
          iskeepAlive:true
        }
      },
      //订单tabCom详情页面
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/tabCom/index'),
        meta: {
          title: '订单列表详情',
        },
        hidden: true
      },
    ]
  }


// WEBPACK FOOTER //
// ./src/router/orderReturn.js